import styled from "styled-components";

export const ModalMask = styled.div<{ open: boolean }>`
  display: ${(props) => (props.open ? "flex" : "none")};
  align-items: center;
  justify-content: center;
  text-align: -webkit-center;
  background-color: #00000090;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 999;
`;

export const ModalContainer = styled.div`
  box-shadow: rgba(0, 0, 0, 0.15) 0px 15px 25px,
    rgba(0, 0, 0, 0.05) 0px 5px 10px;
  background-color: white;
  border-radius: 15px;
  height: max-content;
  max-height: 80vh;
  overflow: auto;
  width: 600px;
  position: relative;
  padding: 40px 30px;
  display: flex;
  flex-direction: column;
  align-items: center;

  h2 {
    margin-bottom: 20px;
    color: #333;
  }

  @media only screen and (max-width: 650px) {
    width: 90%;
    padding: 30px 20px;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 15px;
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 5px;

  &:hover {
    color: #333;
  }
`;

export const AssessmentList = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

export const AssessmentItem = styled.div`
  display: flex;
  flex-direction: column;
  padding: 15px;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background-color: #f5f5f5;
    border-color: #d9d9d9;
  }
`;

export const AssessmentTitle = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: #333;
  display: flex;
  align-items: center;
  margin-bottom: 8px;
`;

export const AssessmentInfo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
`;

export const AssessmentAgency = styled.span`
  color: #666;
`;

export const AssessmentDate = styled.span`
  color: #888;
`;
